const inputModel = {
  bind: function(el, binding, vnode) {
    el.oninput = () => (vnode.context[binding.expression] = el.value)
  },
  update: function(el, binding) {
    el.value = binding.value
  },
}

export default inputModel
